import { render, staticRenderFns } from "./PFTSModal.vue?vue&type=template&id=027375b2&scoped=true"
import script from "./PFTSModal.vue?vue&type=script&lang=js"
export * from "./PFTSModal.vue?vue&type=script&lang=js"
import style0 from "./PFTSModal.vue?vue&type=style&index=0&id=027375b2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027375b2",
  null
  
)

export default component.exports